import React from 'react';
import { TailwindTooltip } from '../../atoms/TailwindTooltip';
import Icon from '~/UI/Icon';

export function ProductTableHeader() {
	return (
		<div className='product-row-header'>
			<div className='w-9 grow-0 shrink-0' />
			<div className='pl-1 w-20 grow-0 shrink-0'>Country</div>
			<div className='pl-3 flex-1'>Brand name</div>
			<div className='pl-3 flex-1'>Company</div>
			<div className='pl-3 flex-1'>Dosage Form</div>
			<div className='pl-3 flex-1'>Dosage strength</div>
			<div className='pl-3 flex-1'>Package</div>
			<div className='pl-3 pr-5 grow-0 shrink-0 w-40 text-right'>
				Price
				<TailwindTooltip
					reference={<Icon name='violet-question-mark' />}
					displayClass='relative -top-px inline-block ml-2 h-4 align-top'
					position='left'
				>
					<p className='leading-snug'>
						<strong>Horní cena:</strong> Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)
					</p>
					<p className='leading-snug'>
						<strong>Spodní cena (zvýrazněná tučně):</strong> Původní cena zveřejněná ve zdroji (Ex-factory price, nebo
						cena sloužící pro přepočet na Ex-factory price).
					</p>
				</TailwindTooltip>
			</div>
			<div className='pl-2 grow-0 shrink-0 w-16 text-right'>Package for calc.</div>
			<div className='pl-3 grow-0 shrink-0 w-32 text-right'>
				Calc. Price
				<TailwindTooltip
					reference={<Icon name='violet-question-mark' />}
					displayClass='relative -top-px inline-block ml-2 h-4 align-top'
					position='left'
				>
					<p className='leading-snug'>
						<strong>Calc. price:</strong> Cena vzniklá vynásobením ceny (pole Price) velikostí balení (pole Package for
						calc.)
					</p>
					<p className='leading-snug'>
						<strong>Horní cena:</strong> Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)
					</p>
					<p className='leading-snug'>
						<strong>Spodní cena (zvýrazněná tučně):</strong> Původní cena zveřejněná ve zdroji (Ex-factory price, nebo
						cena sloužící pro přepočet na Ex-factory price)
					</p>
				</TailwindTooltip>
			</div>
			<div className='w-16 grow-0 shrink-0 text-right'>Use for calc.</div>
			<div className='w-9 grow-0 shrink-0' />
		</div>
	);
}
